// extracted by mini-css-extract-plugin
export default {"merchantDetailsUpdate":"MerchantCreate_merchantDetailsUpdate__vfv-x","merchantDetailsCardWrapper":"MerchantCreate_merchantDetailsCardWrapper__e+Hm5"};